import { Controller } from "@hotwired/stimulus"

// A full picker panel (region & language, currency): centered modal on
// desktop, bottom sheet on mobile. Rendered once in the layout; opened from
// anywhere by a picker-link that dispatches `picker:open` with the panel id.
export default class extends Controller {
  static targets = ["backdrop", "panel"]
  static values = { id: String }

  connect() {
    this.isOpen = false
    this.boundOpenEvent = (e) => { if (e.detail?.id === this.idValue) this.open() }
    this.boundEscape = (e) => { if (e.key === "Escape" && this.isOpen) this.close() }
    window.addEventListener("picker:open", this.boundOpenEvent)
    document.addEventListener("keydown", this.boundEscape)
  }

  disconnect() {
    window.removeEventListener("picker:open", this.boundOpenEvent)
    document.removeEventListener("keydown", this.boundEscape)
    document.body.style.overflow = ""
  }

  open() {
    this.isOpen = true
    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.panelTarget.classList.remove("translate-y-full", "sm:scale-95", "sm:opacity-0")
    })
    document.body.style.overflow = "hidden"
    const current = this.panelTarget.querySelector("[data-picker-current]")
    if (current) setTimeout(() => current.scrollIntoView({ block: "center" }), 50)
  }

  close() {
    this.isOpen = false
    this.backdropTarget.classList.add("opacity-0")
    this.panelTarget.classList.add("translate-y-full", "sm:scale-95", "sm:opacity-0")
    document.body.style.overflow = ""
    setTimeout(() => { if (!this.isOpen) this.element.classList.add("hidden") }, 300)
  }

  stop(event) { event.stopPropagation() }
}
